import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Percent, SlidersHorizontal } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { formatInt, formatMoney, sumCents, lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const StatementsPage = lazyPage(() => import("./StatementsPage"), "StatementsPage");
const StatementPage = lazyPage(() => import("./StatementPage"), "StatementPage");
const RulesPage = lazyPage(() => import("./RulesPage"), "RulesPage");

function CommissionsWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["commissions", "widget", org.id],
    queryFn: () => unwrap<Array<{ status: string; payable_cents: number }>>(from("commissions", "v_statements").select("status, payable_cents").eq("org_id", org.id).eq("status", "computed").limit(1000)),
  });
  const rows = q.data ?? [];
  return (
    <dl className="vx-dl">
      <dt>Extratos a aprovar</dt>
      <dd className="num">{formatInt(rows.length)}</dd>
      <dt>Valor a aprovar</dt>
      <dd className="num">{formatMoney(sumCents(rows.map((r) => r.payable_cents)))}</dd>
      <dt />
      <dd>
        <Link to="/dinheiro/comissoes">Abrir comissões</Link>
      </dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "commissions",
  title: "Comissões",
  domain: "money",
  icon: Percent,
  menu: [
    { path: "/dinheiro/comissoes", label: "Comissões", minRole: "manager", icon: Percent, order: 88, keywords: "repasse parceiro instrutor palestrante extrato apuração" },
    { path: "/dinheiro/regras-de-comissao", label: "Regras de comissão", minRole: "manager", icon: SlidersHorizontal, order: 89, keywords: "faixas beneficiários atribuição simulador" },
  ],
  routes: [
    { path: "/dinheiro/comissoes", element: <StatementsPage />, minRole: "manager" },
    { path: "/dinheiro/comissoes/extratos/:id", element: <StatementPage />, minRole: "manager" },
    { path: "/dinheiro/regras-de-comissao", element: <RulesPage />, minRole: "manager" },
  ],
  widgets: [{ key: "commissions.pending", title: "Comissões", minRole: "manager", span: 1, order: 65, element: CommissionsWidget }],
});
